<template>
    <div>
        <!-- btn -->
        <div :class="btnClass" @click.stop="showPopup.val = true" class="TQ_clickable" :data-hook="DataHooks_o.comp_btn_approved_main">
            <tq-notification-container :num="notificationNum" :show="notificationNum > -1" v-if="imageSrc">
                <img :class=imgClass :src="imageSrc"/>
            </tq-notification-container>
            <div v-if="text">{{text[systemLangCode]}}</div>
            <slot v-else></slot>
        </div>

        <!-- popup -->
        <tq-popup class="popup"
                  :show="showPopup"
                  :show-close-btn="true"
                  padding="0px"
                  maxWidth="350px" >

            <div class="TQ_text_24px TQ_text_bold TQ_bg_purple_dark TQ_padding_8px"> {{ p_popupTitle_s}} </div>
            <div class="TQ_padding_8px">
                <div v-if="popupText"> {{popupText[systemLangCode]}}</div>
                <slot name="popup"></slot>
            </div>

            <div class="TQ_grid_col_Auto1frAuto TQ_padding_8px TQ_border_top">
                <div class="TQ_btn TQ_bg_gray4 TQ_borderRadius"   @click.stop="showPopup.val=false">
                    {{ass_strings.oneWord_cancel[systemLangCode]}}
                </div>
                <div></div>
                <div class="TQ_btn TQ_bg_purple_lite TQ_borderRadius" @click.stop="l_approveCb()" :data-hook="DataHooks_o.comp_btn_approved_btn">
                    {{ass_strings.oneWord_approve[systemLangCode]}}
                </div>
            </div>
        </tq-popup>
    </div>
</template>

<script>
    import TqPopup from "../basic/TqPopup";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {validator_textByLangCode_fb} from "../../../functions/src/shareCode/Share_S_Validator";
    import TqNotificationContainer from "../basic/TqNotificationContainer";
import { DataHooks_o } from "../../scripts/S_DataHooks";
    export default {
        name: "TqBtnApprove",
        components: {TqNotificationContainer, TqPopup},
        props:{
            btnClass:{
                type: String,
            },
            imgClass:{
                type: String,
                default: 'TQ_width_32px'
            },
            systemLangCode:{
                require: true,
                type: String
            },
            text:{
                type: Object,
                validator: validator_textByLangCode_fb,
            },
            p_popupTitle_s:{
                require: true,
                type: String,
                default(){
                    return ass_strings.oneWord_warning[this.systemLangCode]
                }
            },
            popupText:{
                require: true,
                type: Object,
                validator: validator_textByLangCode_fb,
            },
            approveCb:{
                require: true,
                type: Function,
            },
            imageSrc:{
                type: String,
            },
            notificationNum:{
                type: Number,
                default: 0
            }
        },
        data(){
            return {
                ass_strings: ass_strings,
                showPopup: {val: false},
                DataHooks_o
            }
        },
        methods:{
            l_approveCb(){
                this.showPopup.val = false
                this.approveCb()
            }
        },
    }
</script>

<style scoped>
    
    .popup{
        color: #000;
        text-align: center;
    }

</style>